export const submitActions = {
    SUBMIT_STATE: 'SUBMIT_STATE',
    RESET: 'SUBMIT_RESET',
    STORE_USER_COMPANY: 'SUBMIT_STORE_USER_COMPANY'
};
